<template>
  <div class="page_content" v-html="htmlContent" />
</template>

<script setup lang="ts">
import type { ICatalogPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<ICatalogPage>('page-catalog', {
  populate: 'deep',
});

const data = response.data as unknown as ICatalogPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;
</script>
